export default "//static.tradera.net/touchweb/static/output/images/category-beauty-care.827c3dce.svg";